module.exports = __webpack_public_path__ + "img/13.a98abff9.webp";